// extracted by mini-css-extract-plugin
export default {"page":"style_page__Mx2yF","emoji":"style_emoji__tvUbw","title":"style_title__63aCH","subtitle":"style_subtitle__xnw6E","spacer":"style_spacer__rptVy"};